import { memo } from 'react';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { EventRenderer } from './event-renderer';
import { OverlappingEvents } from './overlapping-events';

interface Props {
  columnId: string;
}

const ColumnEventsComponent = ({ columnId }: Props) => {
  const columnInfo = useCalendarGridStore((s) => s.columnsById[columnId]);
  const { headerType } = useCalendarGridStore(['headerType']);

  const eventIds = columnInfo?.eventIds ?? [];

  if (!eventIds.length) return null;

  const canHaveOverlappingEvents = headerType === 'provider' || headerType === 'operatory';

  if (canHaveOverlappingEvents) {
    return <OverlappingEvents eventIds={eventIds} />;
  }

  return eventIds.map((eventId) => <EventRenderer key={eventId} eventId={eventId} columnId={columnId} />);
};

export const ColumnEvents = memo(ColumnEventsComponent);
